import { render, staticRenderFns } from "./DialogAddContent.vue?vue&type=template&id=6acdee5c"
import script from "./DialogAddContent.vue?vue&type=script&lang=js"
export * from "./DialogAddContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports